type PreviousWindowQueryGateInput = {
  isAuthenticated: boolean;
  showDelta: boolean;
  hasPreviousWindowBounds: boolean;
  hasCurrentWindowData: boolean;
};

export const shouldLoadStagePreviousWindowQuery = ({
  isAuthenticated,
  showDelta,
  hasPreviousWindowBounds,
  hasCurrentWindowData,
}: PreviousWindowQueryGateInput): boolean =>
  isAuthenticated && showDelta && hasPreviousWindowBounds && hasCurrentWindowData;

export const shouldShowStagePreviousWindowComparison = ({
  showDelta,
  hasPreviousWindowData,
}: {
  showDelta: boolean;
  hasPreviousWindowData: boolean;
}): boolean => showDelta && hasPreviousWindowData;
